import { Button } from '@/components/Button'
import styles from './DetailsFooter.module.css'
import {
  NotificationBar,
  NotificationBarTitle,
  NotificationBarSubtitle,
} from '@/components/NotificationBar'

export interface DetailsFooterProps {
  jobLink: string
  isJobClosed: boolean
  canResolveScopeChangeRequest: boolean
  isResolved: boolean
  isPendingClientApproval: boolean
  isPendingFinalization: boolean
  isPendingAdminApproval: boolean
  onDecline: () => unknown
  onFinalize: () => unknown
  isFinalizePending: boolean
  onAdminApprove: () => unknown
  isAdminApprovePending: boolean
  onResolve: () => unknown
}

export function DetailsFooter({
  jobLink,
  isJobClosed,
  canResolveScopeChangeRequest,
  isResolved,
  isPendingClientApproval,
  isPendingFinalization,
  isPendingAdminApproval,
  onDecline,
  onFinalize,
  isFinalizePending,
  onAdminApprove,
  isAdminApprovePending,
  onResolve,
}: DetailsFooterProps) {
  return (
    <div className={styles.root}>
      {!isPendingClientApproval && (
        <JobClosedNotificationBar showing={isJobClosed} />
      )}
      <div className={styles.buttonGroupContainer}>
        <Button label="View Job" target="_blank" to={jobLink} />
        {canResolveScopeChangeRequest && !isResolved && (
          <div className={styles.requestActions}>
            {(isPendingFinalization || isPendingAdminApproval) && (
              <Button
                label="Decline"
                testId="scope-change-request-decline"
                isDisabled={isFinalizePending || isAdminApprovePending}
                onPress={onDecline}
              />
            )}
            {isPendingFinalization && (
              <Button
                label="Finalize"
                testId="scope-change-request-finalize"
                onPress={onFinalize}
                variant="primary"
                isPending={isFinalizePending}
                isDisabled={isFinalizePending || isJobClosed}
              />
            )}
            {isPendingAdminApproval && (
              <Button
                label="Accept"
                testId="scope-change-request-admin-approve"
                onPress={onAdminApprove}
                variant="primary"
                isPending={isAdminApprovePending}
                isDisabled={isAdminApprovePending || isJobClosed}
              />
            )}
            {isPendingClientApproval && (
              <Button
                label="Resolve"
                testId="scope-change-request-resolve"
                onPress={onResolve}
                variant="primary"
              />
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export interface JobClosedNotificationBarProps {
  showing: boolean
}

export function JobClosedNotificationBar({
  showing,
}: JobClosedNotificationBarProps) {
  if (!showing) {
    return
  }

  return (
    <NotificationBar centered type="error">
      <NotificationBarTitle>Unable to accept request:</NotificationBarTitle>
      <NotificationBarSubtitle>Job is already closed</NotificationBarSubtitle>
    </NotificationBar>
  )
}
